var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C10.263 5 8.85484 6.42636 8.85484 8.18586C8.85484 9.94537 10.263 11.3717 12 11.3717C13.737 11.3717 15.1452 9.94537 15.1452 8.18586C15.1452 6.42636 13.737 5 12 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64516 13.0709C6.90814 13.0709 5.5 14.4972 5.5 16.2567V17.2662C5.5 17.9062 5.95784 18.4518 6.58132 18.5549C10.17 19.1484 13.83 19.1484 17.4187 18.5549C18.0422 18.4518 18.5 17.9062 18.5 17.2662V16.2567C18.5 14.4972 17.0919 13.0709 15.3548 13.0709H15.0689C14.9142 13.0709 14.7605 13.0956 14.6134 13.1443L13.8874 13.3844C12.661 13.79 11.339 13.79 10.1126 13.3844L9.38664 13.1443C9.23955 13.0956 9.08579 13.0709 8.93105 13.0709H8.64516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7C17.1638 7 16.0806 8.12071 16.0806 9.50318C16.0806 10.8856 17.1638 12.0064 18.5 12.0064C19.8362 12.0064 20.9194 10.8856 20.9194 9.50318C20.9194 8.12071 19.8362 7 18.5 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9194 13.3414C14.5832 13.3414 13.5 15.4621 13.5 16.8446V17.6378C13.5 18.1405 13.8522 18.5692 14.3318 18.6503C17.0923 19.1166 19.9077 18.1166 22.6682 17.6503C23.1478 17.5692 23.5 17.1405 23.5 16.6378V15.8446C23.5 14.4621 22.4168 13.3414 21.0806 13.3414H20.8607C20.7417 13.3414 20.6234 13.3609 20.5103 13.3991L19.9519 13.5877C19.0085 13.9065 17.9915 13.9065 17.0481 13.5877L16.4897 13.3991C16.3766 13.3609 16.2583 13.3414 16.1393 13.3414H15.9194Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7C4.16383 7 3.08065 8.12071 3.08065 9.50318C3.08065 10.8856 4.16383 12.0064 5.5 12.0064C6.83617 12.0064 7.91935 10.8856 7.91935 9.50318C7.91935 8.12071 6.83617 7 5.5 7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91935 13.3414C1.58318 13.3414 0.5 14.4621 0.5 15.8446V16.6378C0.5 17.1405 0.852183 17.5692 1.33179 17.6503C4.09232 18.1166 6.90768 19.1166 9.66821 18.6503C10.1478 18.5692 10.5 18.1405 10.5 17.6378V16.8446C10.5 15.4621 9.41682 13.3414 8.08065 13.3414H7.86073C7.7417 13.3414 7.62342 13.3609 7.51028 13.3991L6.95188 13.5877C6.00847 13.9065 4.99153 13.9065 4.04812 13.5877L3.48972 13.3991C3.37658 13.3609 3.2583 13.3414 3.13927 13.3414H2.91935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWhite);
export default __webpack_public_path__ + "static/media/users-white.30c1b8170e5743a7b83cdff27c1803ea.svg";
export { ForwardRef as ReactComponent };